import React, { Component } from 'react'
import moment from 'moment'

import { TREE_EVENT, INFO_EVENT } from 'shared/dictionaries/events'
import { TRANSPORT_DATE_FORMAT } from 'shared/config/widget'

import { action, computed, observable, reaction } from 'mobx'

import { observer } from 'mobx-react'
import { withStyles } from 'material-ui/styles'

import withAppStore from 'decorators/withAppStore'

import Tooltip from 'material-ui/Tooltip'
import IconButton from 'material-ui/IconButton'
import { AlertBox } from 'mdi-material-ui'

import styles from 'styles/components/CodeInfo'

@withStyles(styles)
@withAppStore
@observer
export default class ToDateNotificator extends Component {
  @observable to_date = null
  @observable redirect_to_date = null
  @observable from_date = moment()

  @computed
  get date() {
    return this.appStore.onDate
  }
  set date(value) {
    this.appStore.onDate = value
  }

  componentWillMount() {
    this.initializeState()
    this.subscribeToStateChanges()
  }

  initializeState() {
    if (this.props.to_date) {
      this.to_date = moment(this.props.to_date, 'YYYY-MM-DD')
      this.redirect_to_date = this.to_date.clone()
      this.redirect_to_date = this.redirect_to_date.add(1, 'days')
    }
    if (this.date) {
      this.from_date = this.date
    }
  }

  subscribeToStateChanges() {
    reaction(
      () => this.appStore.queryParamsStore.queryParams.date,
      () => {
        if (!this.appStore.isLoading) this.appStore.dataStore.reload()
      },
    )
  }

  render() {
    const { dominantMode } = this.appStore
    const limitMonth = 3
    if (this.to_date === null) return ''
    if (this.to_date.diff(this.appStore.onDate, 'month', true) >= limitMonth)
      return ''
    return this.renderNotificationBox(dominantMode)
  }

  renderNotificationBox(isDominantMode) {
    if (!isDominantMode) {
      return (
        <Tooltip
          disableTriggerFocus={true}
          title={`Внимание, действует до ${this.to_date.format('L')}`}
          placement="bottom"
        >
          <AlertBox />
        </Tooltip>
      )
    }
    return (
      <Tooltip
        disableTriggerFocus={true}
        title={`Внимание, действует до ${this.to_date.format('L')}`}
        placement="bottom"
      >
        <IconButton aria-label="Event" onMouseDown={this.handleOnClick}>
          <AlertBox />
        </IconButton>
      </Tooltip>
    )
  }

  @action.bound
  handleOnClick(e) {
    if (e.nativeEvent.which === 1) {
      if (
        this.appStore.widgetOrigin === undefined &&
        (this.appStore.treeLink === null ||
          this.appStore.treeLink === undefined)
      ) {
        if (this.date !== this.redirect_to_date) {
          this.date = this.redirect_to_date
          this.sendEvent()
        }
      } else {
        const date = this.redirect_to_date
          ? this.redirect_to_date.format(TRANSPORT_DATE_FORMAT)
          : null
        var originSelfHref = ''
        if (this.appStore.treeLink) {
          originSelfHref += `${this.appStore.treeLink}/#/date=${date}&info-code=${this.appStore.code}&search-open=false`
        } else {
          if (this.appStore.widgetOrigin !== undefined) {
            originSelfHref += `${this.appStore.widgetOrigin}/#/date=${date}&info-code=${this.appStore.code}&search-open=false`
          }
        }

        if (window.parent !== undefined) {
          try {
            window.parent.location.href = originSelfHref
            window.open(originSelfHref, '_blank')
          } catch (err) {
            window.open(originSelfHref, '_blank')
          }
        } else {
          window.open(originSelfHref, '_blank')
        }
      }
    } else if (e.nativeEvent.which === 2) {
      const date = this.redirect_to_date
        ? this.redirect_to_date.format(TRANSPORT_DATE_FORMAT)
        : null
      if (this.appStore.widgetOrigin === undefined) {
        var newHref = window.location.href.replace(
          /(date=)[\d-]+/g,
          '$1' + date,
        )
        window.open(newHref, '_blank')
      } else {
        var originHref = `${this.appStore.widgetOrigin}/#/date=${date}&info-code=${this.appStore.code}&search-open=false`
        if (this.appStore.treeLink) {
          originHref = `${this.appStore.treeLink}/#/date=${date}&info-code=${this.appStore.code}&search-open=false`
        } 
        window.open(originHref, '_blank')
      }
    }
  }

  sendEvent() {
    const eventName =
      this.appStore.widgetKind === 'tree'
        ? TREE_EVENT.CHANGE_DATE
        : INFO_EVENT.CHANGE_DATE
    const date = this.date ? this.date.format(TRANSPORT_DATE_FORMAT) : null
    this.appStore.sendEvent(eventName, { date })
  }
}



// WEBPACK FOOTER //
// ./src/components/ToDateNotificator.js